import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { Element } from 'react-scroll';

const styles = theme => ({});

const AfitdScrollToElement = props => {
    const { setRef, name, children } = props;
    return (
        <div ref={setRef}>
            <Element name={name}>{children}</Element>
        </div>
    );
};

export default withStyles(styles)(AfitdScrollToElement);
